export default class FishingForecasts {
  static async getForecasts(date) {
    const url = `/fishing_forecasts${date ? '?date=' + date : ''}`;
    return new Promise((resolve, reject) => {
      return fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" }
      })
        .then((response) => response.json())
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  static async refreshForecasts() {
    return new Promise((resolve, reject) => {
      return fetch(`/fishing_forecasts/refresh`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then((response) => response.json())
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }
}
